import React, { memo, useMemo } from "react";
import { Link } from "react-router-dom";
import { FaBuilding, FaMapMarkerAlt } from "react-icons/fa";
import { motion } from "framer-motion";

import {
  getProjectImage,
  getStatusDetails,
} from "../../../utils/admin/projectUtils";

const cardVariants = {
  hidden: {
    opacity: 0,
    y: 50,
  },
  visible: {
    opacity: 1,
    y: 0,
  },
};

function ProjectCard({ project, index = 0 }) {
  const mainImage = useMemo(
    () => getProjectImage(project.image),
    [project.image]
  );

  const status = useMemo(
    () => getStatusDetails(project.status),
    [project.status]
  );

  return (
    <motion.div
      variants={cardVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{
        duration: 0.5,
        delay: index * 0.15,
      }}
      className="relative flex flex-col overflow-hidden rounded-lg border bg-white shadow-sm transition hover:shadow-md group"
    >
      <Link
        to={project.url || "#"}
        className="flex flex-col flex-1"
      >
        <div className="relative">
          <img
            loading="lazy"
            src={mainImage}
            alt={project.name}
            className="h-52 w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />

          {project.status && (
            <span
              className={`absolute top-2 left-2 flex items-center gap-1 rounded px-2 py-1 text-xs text-white shadow-lg ${status.bgColor}`}
            >
              <span>{status.icon}</span>
              <span>{status.label}</span>
            </span>
          )}

          {project.isNew && (
            <span className="absolute top-2 right-2 rounded bg-red-500 px-2 py-1 text-xs text-white">
              Mới
            </span>
          )}
        </div>

        <div className="flex flex-1 flex-col p-4 text-sm text-gray-700 space-y-2">
          <h3 className="line-clamp-2 text-lg font-semibold text-[#0c2c4d]">
            {project.name}
          </h3>

          {project.description && (
            <p className="line-clamp-2 text-gray-600">
              {project.description}
            </p>
          )}

          <div className="flex items-center gap-2 text-xs text-gray-500">
            <FaBuilding />
            {project.developer}
          </div>

          <div className="flex items-center gap-2 text-xs text-gray-500">
            <FaMapMarkerAlt />
            {project.location || "Đang cập nhật"}
          </div>

          {project.yearCompleted && (
            <div className="text-xs text-gray-400">
              Năm hoàn thành: {project.yearCompleted}
            </div>
          )}

          {project.price && (
            <p className="mt-1 text-lg font-bold text-red-600">
              {project.price.toLocaleString("vi-VN")} ₫
            </p>
          )}
        </div>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="rounded-lg bg-[#c9a063] px-4 py-2 font-semibold text-white shadow-lg hover:bg-[#a68652]">
            Xem chi tiết
          </span>
        </div>
      </Link>
    </motion.div>
  );
}

export default memo(ProjectCard);